import api from './api';

export interface AditivoTotvs {
  id: string;
  numero: number;
  codigoEmpresa: string;
  codigoEntabelecimento: string;
  codigoEmitente: string;
  nomeAbrevidoEmitente: string;
  numeroContrato: string;
  dataInicioContrato: string;
  dataFimContrato: string;
  narrativa: string;
  numeroAditivo: string;
  dataConfirmacaoAditivo: string;
  dataAtualizacaoAditivo: string;
  tabelaAditivoTotvs: TabelaAditivo[];
}

export interface AditivoTotvsContrato {
  id: string;
  numero: number;
  codigoEmpresa: string;
  codigoEntabelecimento: string;
  codigoEmitente: string;
  nomeAbrevidoEmitente: string;
  numeroContrato: string;
  dataInicioContrato: string;
  dataFimContrato: string;
  narrativa: string;
  numeroAditivo: string;
  dataConfirmacaoAditivo: string;
  dataAtualizacaoAditivo: string;
  tabelaAditivoTotvs: TabelaAditivo[];
}

export interface TabelaAditivo {
  id: string;
  index: number;
  item: number;
  descricao: string;
  unidade: string;
  quantidadeTotal: string;
  precoUnitario: string;
  valorTotal: string;
  saldo: number;
  saldoFormatado: string;
  itemValorAnterior: number;
  itemValorAnteriorFormatado: string;
  pqId: string;
}

export const getAllAditivoTotvsByContatoId = (id: any) =>
  api.get<AditivoTotvs[]>(`aditivoTotvs/getAllAditivoTotvsByContatoId/${id}`);
export const getAllContratoTotvsByContatoId = (id: any) =>
  api.get<AditivoTotvsContrato[]>(`aditivoTotvs/getAllContratoTotvsByContatoId/${id}`);

export const updateTabelaAditivo = (id: any, form: any) => api.put<any>(`aditivoTotvs/updateTabelaAditivo/`, form);
export const updateTabelaContrato = (id: any, form: any) => api.put<any>(`aditivoTotvs/updateTabelaContrato/`, form);
